import React from 'react';
import { useSelector } from 'react-redux';
import TrailCertificateTable from '../../TrailCertificateTable';

const StudentCertificatesTrail = () => {
  const { id } = useSelector((state) => state.auth);

  return <TrailCertificateTable id_user={id} />;
};

export default React.memo(StudentCertificatesTrail);
